export const OVERTIME_MIN_REASON = 10;
export const OVERTIME_MAX_REASON = 1000;
export const OVERTIME_MAX_CLIENT_EMAILS = 5;
export const OVERTIME_MANAGER_DOMAIN = '@rarolabs.com.br';

const TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function parseTimeToMinutes(value: string): number | null {
    const match = TIME_PATTERN.exec(value);
    return match ? Number(match[1]) * 60 + Number(match[2]) : null;
}

export function overtimeDurationMinutes(startTime: string, endTime: string): number | null {
    const start = parseTimeToMinutes(startTime);
    const end = parseTimeToMinutes(endTime);
    if (start === null || end === null || end <= start) return null;
    return end - start;
}

export function formatDuration(totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours === 0) return `${minutes}min`;
    return minutes === 0 ? `${hours}h` : `${hours}h${String(minutes).padStart(2, '0')}`;
}

export function isValidEmail(value: string): boolean {
    return EMAIL_PATTERN.test(value.trim());
}

export function isRaroManagerEmail(value: string): boolean {
    return isValidEmail(value) && value.trim().toLowerCase().endsWith(OVERTIME_MANAGER_DOMAIN);
}

export function normalizeClientEmails(values: readonly string[]): string[] {
    const seen = new Set<string>();
    const result: string[] = [];
    for (const raw of values) {
        const email = raw.trim().toLowerCase();
        if (email === '' || seen.has(email)) continue;
        seen.add(email);
        result.push(email);
    }
    return result;
}

export function contractRegimeLabel(collaboratorType: string | null | undefined): string {
    if (collaboratorType === 'Celetista') return 'CLT';
    if (collaboratorType === 'Fornecedor') return 'PJ';
    return collaboratorType?.trim() || 'Não informado';
}
